<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: { type: Array, default: () => [] },
});

/**
 * WhatsApp allows one reaction per person per message, so entries arrive keyed by who reacted. Several
 * people picking the same emoji collapse into one chip with a count, and the names go to the tooltip.
 */
const groupedReactions = computed(() => {
  const byEmoji = new Map();

  props.reactions.forEach(({ emoji, name }) => {
    if (!emoji) return;

    const group = byEmoji.get(emoji) ?? { emoji, names: [] };
    if (name) group.names.push(name);
    byEmoji.set(emoji, group);
  });

  return Array.from(byEmoji.values());
});
</script>

<template>
  <div class="flex flex-wrap items-center gap-1">
    <span
      v-for="{ emoji, names } in groupedReactions"
      :key="emoji"
      v-tooltip="names.join(', ')"
      class="inline-flex items-center gap-1 px-1.5 py-0.5 text-xs rounded-full cursor-default bg-n-alpha-2 text-n-slate-12"
    >
      <span>{{ emoji }}</span>
      <span v-if="names.length > 1" class="text-n-slate-11">
        {{ names.length }}
      </span>
    </span>
  </div>
</template>
